import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { stripeClient } from "@better-auth/stripe/client";

export const authClient = createAuthClient({
  plugins: [
    adminClient(),
    stripeClient({
      subscription: true,
    }),
  ],
});

export const { useSession, signIn, signUp, signOut } = authClient;

// Generic OAuth sign-in helper for extensibility
export const signInWithOAuth = async (
  provider: "google" | "github" | "microsoft",
  callbackURL?: string,
) => {
  await authClient.signIn.social({
    provider,
    callbackURL: callbackURL || window.location.origin + "/dashboard",
  });
};

// Convenience wrapper for Google
export const signInWithGoogle = (callbackURL?: string) =>
  signInWithOAuth("google", callbackURL);
